import { render } from "./ParagraphHeading.vue?vue&type=template&id=158acca4&scoped=true&ts=true"
import script from "./ParagraphHeading.vue?vue&type=script&lang=ts"
export * from "./ParagraphHeading.vue?vue&type=script&lang=ts"

import "./ParagraphHeading.vue?vue&type=style&index=0&id=158acca4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158acca4"]])

export default __exports__